import { render } from "./AdminsPage.vue?vue&type=template&id=ee10efd8&scoped=true"
import script from "./AdminsPage.vue?vue&type=script&lang=js"
export * from "./AdminsPage.vue?vue&type=script&lang=js"

import "./AdminsPage.vue?vue&type=style&index=0&id=ee10efd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee10efd8"]])

export default __exports__